// Forced Refresh for Footer
import React, { useState, useEffect } from 'react';
import { FaFacebook, FaInstagram, FaTiktok, FaEnvelope, FaPhone, FaDownload } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './Footer.css';
import logoImg from '../assets/logo.png';

const Footer = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showInstallBtn, setShowInstallBtn] = useState(false);

    useEffect(() => {
        const handleBeforeInstallPrompt = (e) => {
            // Prevent Chrome 67 and earlier from automatically showing the prompt
            e.preventDefault();
            // Stash the event so it can be triggered later.
            setDeferredPrompt(e);
            setShowInstallBtn(true);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) return;

        // Show the install prompt
        deferredPrompt.prompt();

        // Wait for the user to respond to the prompt
        const { outcome } = await deferredPrompt.userChoice;

        if (outcome === 'accepted') {
            console.log('User accepted the install prompt');
        } else {
            console.log('User dismissed the install prompt');
        }

        // We've used the prompt, and can't use it again, throw it away
        setDeferredPrompt(null);
        setShowInstallBtn(false);
    };

    return (
        <footer className="footer">
            <div className="container footer-grid">
                {/* Brand Column */}
                <div className="footer-col brand-col">
                    <div className="logo-container" style={{ marginBottom: '15px' }}>
                        <img src={logoImg} alt="RoulezPropre Logo" className="footer-logo-img" />
                    </div>
                </div>

                {/* Services Column */}
                <div className="footer-col">
                    <h3>SERVICES</h3>
                    <div className="footer-content">
                        <p className="footer-text">Lundi au Dimanche</p>
                        <p className="footer-text">Sur rendez-vous</p>
                        <p className="footer-text" style={{ fontStyle: 'italic', opacity: 0.8 }}>Votre propreté, notre priorité.</p>
                    </div>
                </div>

                {/* Contact Column */}
                <div className="footer-col">
                    <h3>CONTACT</h3>
                    <div className="footer-content">
                        <div className="footer-text">
                            <FaPhone className="text-blue" />
                            <span>07 49 91 55 73</span>
                        </div>
                        <div className="footer-text">
                            <FaEnvelope className="text-blue" />
                            <a href="mailto:roulezpropre@gmail.com">roulezpropre@gmail.com</a>
                        </div>
                    </div>
                </div>

                {/* Follow Column */}
                <div className="footer-col">
                    <h3>SUIVEZ MOI</h3>
                    <div className="social-links">
                        <a href="https://www.facebook.com/profile.php?id=61564698593060&mibextid=LQQJ4d" className="social-btn" target="_blank" rel="noreferrer"><FaFacebook /></a>
                        <a href="https://www.instagram.com/roulezpropre?igsh=MXV0dHRkb3k2NWV2eg%3D%3D&utm_source=qr" className="social-btn" target="_blank" rel="noreferrer"><FaInstagram /></a>
                        <a href="https://www.tiktok.com/@roulezpropre?_t=8owVUKEEqtE&_r=1" className="social-btn" target="_blank" rel="noreferrer"><FaTiktok /></a>
                    </div>
                </div>
            </div>

            {showInstallBtn && (
                <div className="container footer-install-row">
                    <button onClick={handleInstallClick} className="btn-install-app">
                        <FaDownload /> Installer l'application
                    </button>
                </div>
            )}

            <div className="container footer-bottom">
                <p>&copy; 2024 par RoulezPropre</p>
                <Link to="/confidentialite">Politique de confidentialité</Link>
            </div>
        </footer>
    );
};

export default Footer;
